import styled from 'styled-components';

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => (props.$wrap ? '8px 24px' : '28px')};
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
  flex-shrink: 0;

  /* Padrao: uma linha so, rolando na horizontal. A barra e escondida porque
     cortaria a linha da aba ativa — o efeito colateral e que a aba que nao
     cabe some sem aviso, entao onde a barra e o filtro principal use $wrap. */
  ${(props) =>
    props.$wrap
      ? `flex-wrap: wrap;`
      : `
        overflow-x: auto;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
      `}
`;

export const TabItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 2px;
  background: transparent;
  border: none;
  /* fica sobre a linha do container em vez de empurrar o conteudo */
  border-bottom: 2px solid
    ${(props) => (props.$active ? props.color : 'transparent')};
  margin-bottom: -1px;
  color: ${(props) => (props.$active ? props.color : '#4a5568')};
  font-family: 'Kumbh Sans';
  font-size: ${(props) => (props.$small ? '13px' : '15px')};
  font-weight: ${(props) => (props.$active ? 600 : 500)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};
  white-space: nowrap;
  transition: 0.2s;

  &:hover {
    color: ${(props) => (props.disabled ? '#4a5568' : props.color)};
  }
`;

export const TabBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
  color: ${(props) => (props.$active ? '#ffffff' : '#4a5568')};
  background: ${(props) => (props.$active ? props.color : '#e2e8f0')};
`;
